import 'promise-polyfill';
import 'whatwg-fetch';

import mobileNavigation from './modules/mobileNavigation';
import searchFormToggle from './modules/searchFormToggle';
import enableTabbing from './modules/enableTabbing';
import isStyleBlackBlock from './modules/isStyleBlackBlock';
import relatedArticles from './modules/relatedArticles';
import addToCalendar from './modules/addToCalendar';
import singleOrganisationPageToggle from './modules/singleOrganisationPageToggle';

mobileNavigation();
searchFormToggle();
enableTabbing();
isStyleBlackBlock();
relatedArticles();
addToCalendar();
singleOrganisationPageToggle();
